import { useEffect, useRef } from 'react'
import { useQueryClient } from '@tanstack/react-query'
import { useAuth } from '../hooks/useAuth'
import { mergeAnonymousCart } from '../services/cartService'

const CartInitializer = () => {
  const { token, user } = useAuth()
  const queryClient = useQueryClient()
  const prevTokenRef = useRef(token)

  useEffect(() => {
    const wasLoggedOut = !prevTokenRef.current
    const isNowLoggedIn = !!token && !!user
    prevTokenRef.current = token

    if (wasLoggedOut && isNowLoggedIn) {
      const cachedData = queryClient.getQueryData(['cart'])
      const anonItems = cachedData?.items || []

      mergeAnonymousCart(anonItems)
        .catch(() => {})
        .finally(() => {
          localStorage.removeItem('anon_cart')
          queryClient.invalidateQueries({ queryKey: ['cart'] })
        })
    } else {
      queryClient.invalidateQueries({ queryKey: ['cart'] })
    }
    // The signed-in account changing (its id) is the event; a profile edit is not.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token, user?.id, queryClient])

  return null
}

export default CartInitializer
